export const categories = [
  { name: '网曝门', slug: 'wangbaomen', icon: 'ri-fire-line', description: '最新网曝事件，第一时间追踪报道' },
  { name: '每日大赛', slug: 'daily-contest', icon: 'ri-trophy-line', description: '每日精彩赛事，不容错过的热点' },
  { name: '网红猛料', slug: 'wanghong', icon: 'ri-star-line', description: '网红圈最新动态与八卦猛料' },
  { name: '视频不打烊', slug: 'video', icon: 'ri-vidicon-line', description: '精彩视频24小时不间断更新' },
  { name: '吃瓜前线', slug: 'chigua', icon: 'ri-chat-smile-2-line', description: '吃瓜群众第一线，热点追踪' },
  { name: '黑料实锤', slug: 'heiliao', icon: 'ri-search-eye-line', description: '深度挖掘，实锤黑料大揭秘' },
];

export const tags = ['吃瓜', '黑料', '爆料', '实锤', '网红', '娱乐圈', '热搜', '头条', '八卦', '热门'];

export const articles = [
  {
    id: 'art-001',
    title: '某知名网红被曝私生活混乱，多位当事人出面回应引热议',
    excerpt: '近日，一位拥有千万粉丝的知名网红被曝出私生活问题，多位圈内人士纷纷出面爆料，引发全网热议。事件持续发酵中...',
    content: `<p>近日，一位拥有千万粉丝的知名网红被曝出私生活混乱的问题，该事件在社交媒体上迅速发酵，成为当下最热门的话题之一。</p>
    <p>据知情人士透露，这位网红在成名之前就有过多段不为人知的感情经历。多位自称是当事人的网友在社交平台上发布了相关证据，其中包括聊天记录截图和私密照片。</p>
    <h2>事件始末</h2>
    <p>事件的起因是一位自称是该网红前女友的网友在社交平台上发布了一篇长文，详细描述了两人交往期间的种种细节。文章中提到的内容包括感情纠葛、经济纠纷以及一些不为人知的私密话题。</p>
    <p>随后，又有几位自称与该网红有过接触的人士纷纷出面，从不同角度佐证了这些说法。一时间，相关话题登上了多个社交平台的热搜榜。</p>
    <h2>当事人回应</h2>
    <p>面对舆论压力，该网红在个人社交账号上发布了一段视频回应。视频中，他否认了大部分指控，称这些都是恶意造谣，并表示将通过法律途径维护自己的权益。</p>
    <p>然而，他的回应并未平息争议，反而引发了更多网友的质疑。有网友指出，他在视频中的表述存在多处前后矛盾的地方。</p>
    <h2>业内人士分析</h2>
    <p>多位娱乐圈资深人士对此事发表了看法。有分析认为，这类事件在网红圈并不罕见，背后往往涉及到复杂的利益关系。</p>
    <p>一位不愿透露姓名的经纪公司高管表示：\"网红行业的发展速度太快，很多规范还没有跟上。这次事件可能会对整个行业产生深远的影响。\"</p>
    <h2>网友反应</h2>
    <p>截至目前，相关话题的讨论量已经突破了千万级别。网友们的态度也呈现两极分化的趋势：一部分人选择相信爆料内容，另一部分人则认为应该等待更多证据出现再做判断。</p>
    <p>本网将持续关注此事件的后续发展，为读者带来最新报道。</p>`,
    category: '网红猛料',
    categorySlug: 'wanghong',
    imageUrl: 'https://readdy.ai/api/search-image?query=Abstract%20modern%20illustration%20of%20social%20media%20drama%20and%20gossip%20culture%2C%20warm%20coral%20and%20peach%20tones%2C%20stylized%20figures%20in%20silhouette%2C%20dramatic%20lighting%2C%20editorial%20design%20aesthetic%2C%20minimalist%20composition%20with%20negative%20space%2C%20soft%20gradients%2C%20contemporary%20pop%20art%20influence%2C%20clean%20background%20with%20subtle%20geometric%20patterns&width=800&height=500&seq=art-001-main&orientation=landscape',
    author: '吃瓜小编',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Abstract%20minimalist%20avatar%20illustration%20warm%20peach%20tones%20simple%20geometric%20face%20profile%20clean%20background%20modern%20design&width=120&height=120&seq=author-avatar-001&orientation=squarish',
    authorBio: '资深娱乐记者，专注网红圈动态报道5年',
    publishDate: '2026-07-06',
    isTop: true,
    isHot: true,
    commentCount: 3267,
    viewCount: 128900,
    tags: ['网红', '爆料', '吃瓜'],
    relatedIds: ['art-007', 'art-004', 'art-011'],
  },
  {
    id: 'art-002',
    title: '娱乐圈再爆大瓜！某顶流艺人税务问题被查，涉及金额惊人',
    excerpt: '据知情人士透露，某位顶级流量艺人因税务问题正在接受调查，涉案金额高达数千万。粉丝群体反应激烈，工作室暂未回应。',
    content: `<p>据知情人士透露，某位拥有顶级流量的艺人因涉嫌严重税务问题，目前正在接受相关部门的调查。据悉，涉案金额高达数千万元。</p>
    <h2>调查背景</h2>
    <p>近年来，监管部门对娱乐圈的税务问题持续保持高压态势。此前已有多位知名艺人因类似问题受到处罚，包括补缴税款和高额罚款。</p>
    <p>据接近调查组的消息人士透露，此次被调查的艺人在过去几年的收入申报中存在明显异常，涉及多个代言合同和商业活动的收入未如实申报。</p>
    <h2>粉丝反应</h2>
    <p>消息传出后，该艺人的粉丝群体反应激烈。一部分粉丝表示相信偶像的清白，认为这是恶意造谣；另一部分则表现出担忧，呼吁工作室尽快出面澄清。</p>
    <p>粉丝后援会发布声明称：\"我们相信法律的公正，也会一如既往地支持我们的偶像。希望外界不要过度解读和猜测。\"</p>
    <h2>工作室态度</h2>
    <p>截至目前，该艺人的工作室尚未对此事做出正式回应。有媒体尝试联系其经纪人，但电话一直无人接听。</p>
    <p>有业内人士分析认为，工作室的沉默可能意味着事态的严重性超出了预期，内部正在进行紧急的危机公关处理。</p>
    <h2>行业影响</h2>
    <p>这起事件再次引发了公众对娱乐圈税务合规问题的关注。多位法律专家在接受采访时表示，艺人作为高收入群体，应当更加注重依法纳税。</p>
    <p>本网将持续关注事件进展，为读者带来最新消息。</p>`,
    category: '网曝门',
    categorySlug: 'wangbaomen',
    imageUrl: 'https://readdy.ai/api/search-image?query=Abstract%20illustration%20of%20entertainment%20industry%20scandal%2C%20warm%20amber%20and%20gold%20tones%2C%20stylized%20courtroom%20or%20investigation%20theme%2C%20dramatic%20contrast%20lighting%2C%20editorial%20magazine%20cover%20style%2C%20minimalist%20modern%20design%20with%20clean%20lines%2C%20subtle%20paper%20texture%20overlay%2C%20sophisticated%20aesthetic&width=800&height=500&seq=art-002-main&orientation=landscape',
    author: '深度调查员',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Abstract%20minimalist%20avatar%20illustration%20warm%20amber%20tones%20geometric%20abstract%20face%20clean%20background%20contemporary%20art%20style&width=120&height=120&seq=author-avatar-002&orientation=squarish',
    authorBio: '深度调查记者，擅长挖掘娱乐圈幕后真相',
    publishDate: '2026-07-06',
    isTop: true,
    isHot: true,
    commentCount: 5892,
    viewCount: 256700,
    tags: ['娱乐圈', '黑料', '实锤'],
    relatedIds: ['art-009', 'art-005', 'art-012'],
  },
  {
    id: 'art-003',
    title: '每日大赛：今日最火爆对决，两大主播正面交锋全程回顾',
    excerpt: '今日大赛精彩纷呈，两大顶级主播在直播间展开激烈对决，双方粉丝阵营火药味十足，创下平台同时在线观看人数新纪录。',
    content: `<p>今日的每日大赛迎来了本月最受瞩目的一场对决——两大顶级主播在直播间展开了一场激烈的正面交锋。整场比赛持续了近三个小时，创下了该平台同时在线观看人数的历史新纪录。</p>
    <h2>赛前预热</h2>
    <p>这场对决的消息早在三天前就在社交媒体上传开。两位主播各自的粉丝阵营在赛前就已经展开了激烈的\"舆论战\"，相关话题频频登上热搜。</p>
    <p>一位自称是圈内人士的网友爆料称，两位主播之间其实早有恩怨，这次公开对决既是商业行为，也带有一定的私人色彩。</p>
    <h2>比赛过程</h2>
    <p>比赛于晚上8点正式开始。第一阶段是才艺展示环节，两位主播各自拿出了看家本领。A主播选择了唱歌，B主播则展示了自学的舞蹈。</p>
    <p>进入第二阶段后，火药味明显变浓。两位主播开始互相调侃对方的短板，直播间弹幕瞬间刷屏，服务器一度出现卡顿。</p>
    <p>最终阶段是最激烈的PK环节。双方粉丝疯狂刷礼物，直播间的热度值一路飙升，最终双双突破了历史记录。</p>
    <h2>赛后反响</h2>
    <p>比赛结束后，相关话题在多个平台持续霸榜。网友们的讨论热情丝毫未减，各种剪辑视频和表情包在社交平台上广泛传播。</p>
    <p>有媒体评论称，这场对决不仅展现了两大主播的实力，也再次证明了直播行业的巨大商业价值和影响力。</p>`,
    category: '每日大赛',
    categorySlug: 'daily-contest',
    imageUrl: 'https://readdy.ai/api/search-image?query=Abstract%20dynamic%20illustration%20of%20live%20streaming%20competition%2C%20energetic%20warm%20orange%20and%20red%20tones%2C%20stylized%20digital%20battle%20arena%2C%20neon%20accents%2C%20modern%20esports%20aesthetic%2C%20dramatic%20motion%20effects%2C%20clean%20dark%20background%20with%20glowing%20elements%2C%20futuristic%20yet%20warm%20atmosphere&width=800&height=500&seq=art-003-main&orientation=landscape',
    author: '赛事观察员',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Abstract%20minimalist%20avatar%20illustration%20warm%20terracotta%20tones%20geometric%20abstract%20portrait%20clean%20background%20modern%20artistic%20style&width=120&height=120&seq=author-avatar-003&orientation=squarish',
    authorBio: '直播赛事专业评论员，见证过上千场精彩对决',
    publishDate: '2026-07-05',
    isTop: false,
    isHot: true,
    commentCount: 4215,
    viewCount: 189300,
    tags: ['每日大赛', '直播', '热门'],
    relatedIds: ['art-010', 'art-006', 'art-001'],
  },
  {
    id: 'art-004',
    title: '某女星深夜密会神秘男子，恋情曝光后工作室紧急公关',
    excerpt: '记者拍到某当红女星深夜与一神秘男子同回住所，举止亲密。消息传出后，女方工作室连夜发布声明，但网友并不买账。',
    content: `<p>昨日深夜，有媒体拍到了某当红女星与一位神秘男子同回住所的画面。两人举止亲密，疑似恋情曝光。这一消息迅速在网络上引发热议。</p>
    <h2>拍摄细节</h2>
    <p>据拍摄记者描述，当晚约11点左右，该女星从某高档餐厅出来后，与一名男子一同上了一辆黑色商务车。车辆直接驶向了女方位于市中心的高档公寓。</p>
    <p>两人在车内时有说有笑，男子还多次为女方整理头发，举止十分亲密。到达公寓后，两人一同步入电梯，直到凌晨两点男子才独自离开。</p>
    <h2>工作室回应</h2>
    <p>消息曝光后，女方工作室在凌晨紧急发布了一则声明。声明中称，该男子只是女方多年的好友兼合作伙伴，两人的见面纯属正常社交活动。</p>
    <p>声明还强调：\"请大家不要过度解读，给艺人留一些私人空间。如若继续恶意传播不实信息，我们将保留追究法律责任的权利。\"</p>
    <h2>网友质疑</h2>
    <p>然而，网友似乎并不买账。有细心的网友扒出了更多细节，包括两人在社交媒体上的互动记录和共同出现的场合。</p>
    <p>一位自称是圈内化妆师的网友透露：\"其实他们在一起已经有一段时间了，只是不想公开而已。这在圈内已经不是秘密了。\"</p>
    <h2>男方身份</h2>
    <p>经多方核实，该神秘男子疑为某知名企业的年轻高管，身价不菲。两人疑似通过共同好友介绍认识。</p>`,
    category: '吃瓜前线',
    categorySlug: 'chigua',
    imageUrl: 'https://readdy.ai/api/search-image?query=Abstract%20illustration%20of%20celebrity%20romance%20scandal%2C%20soft%20pink%20and%20rose%20tones%2C%20stylized%20paparazzi%20photography%20theme%2C%20blurred%20city%20night%20lights%2C%20romantic%20yet%20mysterious%20atmosphere%2C%20film%20noir%20influence%2C%20elegant%20minimalist%20composition%2C%20dreamy%20bokeh%20effect%20background&width=800&height=500&seq=art-004-main&orientation=landscape',
    author: '娱乐前线记者',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Abstract%20minimalist%20avatar%20illustration%20soft%20pink%20tones%20stylized%20face%20silhouette%20clean%20background%20modern%20graphic%20design&width=120&height=120&seq=author-avatar-004&orientation=squarish',
    authorBio: '娱乐前线资深记者，娱乐圈八卦第一手消息源',
    publishDate: '2026-07-05',
    isTop: false,
    isHot: true,
    commentCount: 7823,
    viewCount: 345600,
    tags: ['娱乐圈', '吃瓜', '八卦'],
    relatedIds: ['art-011', 'art-001', 'art-008'],
  },
  {
    id: 'art-005',
    title: '实锤！某品牌代言人涉嫌虚假宣传，消费者集体维权进行中',
    excerpt: '多位消费者联合举报某知名品牌代言人涉嫌虚假宣传，相关部门已介入调查。该代言人社交账号评论区已沦陷，事态持续升级。',
    content: `<p>近日，多位消费者联合举报某知名品牌代言人涉嫌虚假宣传，事件持续发酵。相关部门已正式介入调查，该代言人的社交账号评论区已经彻底沦陷。</p>
    <h2>事件起因</h2>
    <p>事件的导火索是该代言人在直播中推荐的一款产品。在直播中，代言人声称该产品具有多项\"神奇功效\"，并展示了所谓的\"使用前后对比\"。</p>
    <p>然而，大量消费者在使用后发现产品效果与宣传严重不符。有消费者将产品送去检测，结果显示其主要成分与普通同类产品并无本质区别。</p>
    <h2>集体维权</h2>
    <p>失望的消费者在社交平台上自发组织起来，形成了一个维权群体。截至目前，参与维权的人数已经超过了5000人。</p>
    <p>维权代表表示，他们已经委托律师向相关部门提交了举报材料，要求对该代言人及其背后的品牌方进行调查和处罚。</p>
    <h2>法律分析</h2>
    <p>多位法律专家在接受采访时表示，如果调查结果证实了虚假宣传的指控，代言人可能需要承担连带责任。</p>
    <p>根据《广告法》的相关规定，广告代言人明知或者应知广告虚假仍进行代言的，应当与广告主承担连带责任。</p>
    <h2>品牌方回应</h2>
    <p>品牌方发布声明称，将积极配合相关部门的调查，并对消费者的反馈表示重视。但声明中并未直接承认虚假宣传的问题。</p>`,
    category: '黑料实锤',
    categorySlug: 'heiliao',
    imageUrl: 'https://readdy.ai/api/search-image?query=Abstract%20illustration%20of%20consumer%20rights%20and%20brand%20scandal%2C%20muted%20earthy%20brown%20and%20beige%20tones%2C%20stylized%20protest%20theme%2C%20hand%20holding%20magnifying%20glass%2C%20clean%20modern%20editorial%20style%2C%20minimalist%20composition%2C%20soft%20shadows%2C%20sophisticated%20neutral%20background&width=800&height=500&seq=art-005-main&orientation=landscape',
    author: '消费维权记者',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Abstract%20minimalist%20avatar%20illustration%20soft%20beige%20tones%20simple%20geometric%20shape%20profile%20clean%20background%20minimal%20design&width=120&height=120&seq=author-avatar-005&orientation=squarish',
    authorBio: '消费维权领域专业记者，为消费者发声',
    publishDate: '2026-07-04',
    isTop: false,
    isHot: false,
    commentCount: 2134,
    viewCount: 98700,
    tags: ['黑料', '实锤', '热搜'],
    relatedIds: ['art-012', 'art-002', 'art-009'],
  },
  {
    id: 'art-006',
    title: '视频不打烊：本周最火爆短视频合集，每一个都让人大跌眼镜',
    excerpt: '精选本周最火爆的短视频内容，从街头偶遇到明星翻车，从搞笑段子到社会热点，全程高能无尿点，不看后悔系列。',
    content: `<p>本周的短视频圈可谓是精彩纷呈，各种高能内容层出不穷。我们精选了本周最火爆的十大短视频，为大家带来一场视觉盛宴。</p>
    <h2>TOP 1：街头偶遇明星翻车现场</h2>
    <p>一段在某商场拍摄的视频在本周疯狂传播。视频中，一位知名艺人在商场购物时被粉丝认出，慌乱中竟然撞到了展示架，场面一度十分尴尬。</p>
    <p>该视频在短短24小时内就获得了超过500万的播放量。网友纷纷评论：\"这是今年最好笑的偶遇视频了！\"</p>
    <h2>TOP 2：外卖小哥神级救场</h2>
    <p>一段外卖小哥在送餐途中\"顺手\"帮一位街头艺人完成表演的视频感动了无数网友。视频显示，这位外卖小哥在等餐时，看到一位盲人街头艺人的乐器出了问题，便上前帮忙修理。</p>
    <p>修理完成后，他还与艺人即兴合奏了一曲，引来了路人的阵阵掌声。</p>
    <h2>TOP 3：宠物界\"奥斯卡\"</h2>
    <p>一只哈士奇在主人不在家时\"大闹天宫\"的监控视频成为本周的快乐源泉。视频中，这只二哈不仅拆了沙发，还把主人的鞋柜翻了个底朝天，最后还一脸无辜地看着摄像头。</p>
    <h2>更多精彩</h2>
    <p>除了以上三个视频，本周还有更多不容错过的精彩内容。从搞笑挑战到感人瞬间，从才艺展示到社会热点，每一段视频都值得一看。</p>
    <p>关注51吃瓜黑料网\"视频不打烊\"频道，精彩内容每日更新，永不停更！</p>`,
    category: '视频不打烊',
    categorySlug: 'video',
    imageUrl: 'https://readdy.ai/api/search-image?query=Abstract%20illustration%20of%20viral%20short%20video%20compilation%2C%20vibrant%20coral%20and%20warm%20yellow%20tones%2C%20stylized%20play%20button%20and%20film%20reel%20elements%2C%20modern%20social%20media%20aesthetic%2C%20dynamic%20composition%20with%20motion%20lines%2C%20clean%20light%20background%2C%20playful%20and%20energetic%20mood&width=800&height=500&seq=art-006-main&orientation=landscape',
    author: '视频编辑小组',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Abstract%20minimalist%20avatar%20illustration%20warm%20coral%20tones%20simple%20circle%20face%20design%20clean%20background%20modern%20flat%20style&width=120&height=120&seq=author-avatar-006&orientation=squarish',
    authorBio: '51吃瓜视频团队，每日精选全网最热视频',
    publishDate: '2026-07-04',
    isTop: false,
    isHot: false,
    commentCount: 1567,
    viewCount: 76200,
    tags: ['视频', '吃瓜', '热门'],
    relatedIds: ['art-003', 'art-010', 'art-008'],
  },
  {
    id: 'art-007',
    title: '网红圈大地震！多位头部主播涉嫌数据造假被平台处罚',
    excerpt: '平台官方发布公告，对多位涉嫌数据造假的头部主播进行处罚，包括限流、封禁直播等功能。行业内幕再次引发公众关注。',
    content: `<p>今日，某大型直播平台官方发布了一则重磅公告：对多位涉嫌数据造假的头部主播进行了不同程度的处罚。这一消息在网红圈引起了巨大震动。</p>
    <h2>处罚详情</h2>
    <p>根据平台公告，此次被处罚的主播共有12位，全部都是拥有百万以上粉丝的头部主播。处罚措施包括：限制流量推荐、暂停直播功能7至30天不等、扣除违规收入等。</p>
    <p>平台方表示，这些主播存在通过技术手段刷量、购买虚假粉丝、利用机器人制造虚假互动等行为，严重违反了平台的规定。</p>
    <h2>涉事主播反应</h2>
    <p>处罚公告发布后，部分涉事主播在个人社交账号上做出了回应。有的表示接受处罚并道歉，有的则否认指控，声称是\"被竞争对手恶意举报\"。</p>
    <p>其中一位拥有500万粉丝的主播发布了一段泪流满面的道歉视频，引发了粉丝的心疼和支持，但也遭到了不少网友的嘲讽。</p>
    <h2>行业影响</h2>
    <p>此次事件再次将直播行业的数据造假问题推到了风口浪尖。有业内人士透露，数据造假在行业内已经是一个\"公开的秘密\"，只是之前很少有平台愿意大力整治。</p>
    <p>一位行业分析师表示：\"这次平台的行动力度之大前所未有，说明行业整顿已经开始动真格了。这对整个行业的健康发展来说是一个积极的信号。\"</p>
    <h2>广告主反应</h2>
    <p>多位与此前被处罚主播有合作关系的品牌方也受到了影响。有品牌方表示，将重新评估与涉事主播的合作关系，部分品牌已经暂停了相关的推广计划。</p>`,
    category: '网红猛料',
    categorySlug: 'wanghong',
    imageUrl: 'https://readdy.ai/api/search-image?query=Abstract%20illustration%20of%20digital%20data%20manipulation%20scandal%2C%20cool%20mint%20green%20and%20grey%20tones%2C%20stylized%20graphs%20and%20charts%20falling%20apart%2C%20modern%20tech%20critique%20aesthetic%2C%20clean%20geometric%20composition%2C%20subtle%20grid%20background%2C%20sophisticated%20editorial%20style&width=800&height=500&seq=art-007-main&orientation=landscape',
    author: '行业观察家',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Abstract%20minimalist%20avatar%20illustration%20muted%20sage%20tones%20abstract%20geometric%20portrait%20clean%20background%20modern%20design&width=120&height=120&seq=author-avatar-007&orientation=squarish',
    authorBio: '直播行业深度观察者，掌握一手行业动态',
    publishDate: '2026-07-03',
    isTop: false,
    isHot: true,
    commentCount: 4532,
    viewCount: 201400,
    tags: ['网红', '黑料', '爆料'],
    relatedIds: ['art-001', 'art-005', 'art-012'],
  },
  {
    id: 'art-008',
    title: '吃瓜前线：某综艺节目录制现场突发状况，导演组紧急叫停',
    excerpt: '据现场观众爆料，某热门综艺节目在录制过程中突发意外状况，导致录制工作中断。节目组目前尚未对外发布正式声明。',
    content: `<p>据多位现场观众爆料，某热门综艺节目在昨日的录制过程中发生了突发状况，导致录制工作被迫中断。目前节目组尚未对此事发布正式声明。</p>
    <h2>事发经过</h2>
    <p>据现场观众描述，事发时节目正在进行一个互动游戏环节。在游戏过程中，一位嘉宾突然表示身体不适，随后出现了短暂的意识模糊。</p>
    <p>现场工作人员立即上前进行了紧急处理，导演组随即决定暂停录制。医护人员在约15分钟后到达现场，对该嘉宾进行了检查。</p>
    <h2>嘉宾状况</h2>
    <p>据知情人士透露，该嘉宾可能是因为连续多日高强度录制导致的身体透支。经过休息和治疗后，目前身体状况已经稳定。</p>
    <p>该嘉宾的经纪团队发布消息称：\"感谢大家的关心，目前一切安好。请大家不要过度担心，也不要传播不实消息。\"</p>
    <h2>节目组态度</h2>
    <p>截至目前，节目组官方尚未发布任何正式声明。但有工作人员私下透露，节目组正在评估是否需要调整后续的录制计划。</p>
    <p>有媒体报道称，这已经不是该节目第一次发生录制事故。此前也曾经因为场地问题和设备故障导致录制中断。</p>
    <h2>网友热议</h2>
    <p>事件曝光后，网友们对节目组的工作安排提出了质疑。很多人认为，综艺节目的录制强度过大，对艺人的身体负担过重。</p>
    <p>有人评论道：\"为了收视率和话题度，把艺人往死里整，这样真的好吗？\"</p>`,
    category: '吃瓜前线',
    categorySlug: 'chigua',
    imageUrl: 'https://readdy.ai/api/search-image?query=Abstract%20illustration%20of%20TV%20show%20production%20chaos%2C%20warm%20peach%20and%20soft%20lavender%20tones%2C%20stylized%20behind%20the%20scenes%20theme%2C%20camera%20equipment%20silhouettes%2C%20dramatic%20yet%20elegant%20composition%2C%20modern%20editorial%20aesthetic%2C%20clean%20light%20background&width=800&height=500&seq=art-008-main&orientation=landscape',
    author: '综艺前线记者',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Abstract%20minimalist%20avatar%20illustration%20warm%20lavender%20tones%20stylized%20abstract%20face%20clean%20background%20contemporary%20design&width=120&height=120&seq=author-avatar-008&orientation=squarish',
    authorBio: '综艺节目资深记者，深入各大录制现场',
    publishDate: '2026-07-03',
    isTop: false,
    isHot: false,
    commentCount: 3245,
    viewCount: 145600,
    tags: ['吃瓜', '综艺', '八卦'],
    relatedIds: ['art-004', 'art-001', 'art-011'],
  },
  {
    id: 'art-009',
    title: '网曝门最新进展：某知名企业家私密对话录音流出',
    excerpt: '一段据称是某知名企业家的私密对话录音在网络上流传，内容涉及商业机密和个人隐私。法律专家表示这可能涉及多项违法行为。',
    content: `<p>一段据称是某知名企业家的私密对话录音近日在网络上广泛流传，内容涉及商业机密和个人隐私，引发了社会各界的广泛关注。</p>
    <h2>录音内容</h2>
    <p>这段时长约18分钟的录音中，可以清晰地听到一个被指认为该企业家的声音在与人交谈。对话内容涉及多个敏感的商务话题，包括对竞争对手的负面评价和一些商业运作的内幕。</p>
    <p>其中最引人关注的是，录音中的对话涉及到了对某些政府官员的\"特殊安排\"，这引起了公众对于是否存在腐败问题的担忧。</p>
    <h2>录音来源</h2>
    <p>目前尚不清楚这段录音的具体来源和录制时间。有分析认为，这可能是内部人员泄露，也有可能是竞争对手的有意为之。</p>
    <p>网络安全专家表示，这类录音的泄露通常有三种途径：设备被黑客入侵、内部人员秘密录制、或是物理场所被安装了窃听设备。</p>
    <h2>法律分析</h2>
    <p>多位法律专家在接受采访时表示，未经他人同意私自录制对话并在网络上传播，可能涉及多项违法行为，包括侵犯隐私权、侵犯商业秘密等。</p>
    <p>同时，如果录音内容是伪造的，那么制作者还可能面临诽谤罪的指控。</p>
    <h2>当事人反应</h2>
    <p>截至目前，被指认为录音主角的企业家及其公司均未对此事做出公开回应。但有消息称，其律师团队已经开始着手处理此事。</p>
    <p>相关监管部门也表示，已经注意到了这一事件，将密切关注事态的发展。</p>`,
    category: '网曝门',
    categorySlug: 'wangbaomen',
    imageUrl: 'https://readdy.ai/api/search-image?query=Abstract%20illustration%20of%20leaked%20audio%20recording%20controversy%2C%20deep%20burgundy%20and%20dark%20gold%20tones%2C%20stylized%20sound%20waves%20and%20voice%20patterns%2C%20mysterious%20noir%20atmosphere%2C%20modern%20investigative%20journalism%20aesthetic%2C%20dramatic%20shadows%2C%20elegant%20dark%20background&width=800&height=500&seq=art-009-main&orientation=landscape',
    author: '深度调查组',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Abstract%20minimalist%20avatar%20illustration%20deep%20burgundy%20tones%20geometric%20profile%20clean%20background%20dark%20aesthetic&width=120&height=120&seq=author-avatar-009&orientation=squarish',
    authorBio: '调查报道团队，揭秘不为人知的商业内幕',
    publishDate: '2026-07-02',
    isTop: false,
    isHot: true,
    commentCount: 6789,
    viewCount: 312000,
    tags: ['网曝门', '黑料', '热搜'],
    relatedIds: ['art-002', 'art-005', 'art-012'],
  },
  {
    id: 'art-010',
    title: '每日大赛精彩回顾：上周五大经典对决，场场都是神仙打架',
    excerpt: '回顾上周五大经典对决，从主播PK到明星互怼，每一场都精彩绝伦。我们为你整理了最全回顾和网友神评论合集。',
    content: `<p>上周的每日大赛可谓是精彩纷呈，五大经典对决各具特色，从主播PK到明星互怼，每一场都让观众大呼过瘾。让我们一起来回顾这些精彩瞬间。</p>
    <h2>第一场：才艺女王之争</h2>
    <p>两位以才艺著称的女主播在上周一展开了一场激烈的才艺对决。从唱歌到舞蹈，从乐器到绘画，两人几乎把能展现的才艺都拿了出来。最终，A主播以微弱优势胜出。</p>
    <h2>第二场：游戏大神巅峰对决</h2>
    <p>周二的对决在游戏圈引起了轰动。两位顶级游戏主播在一款热门竞技游戏中进行了五局三胜的较量，比赛过程精彩刺激，弹幕互动量创下了当月新高。</p>
    <h2>第三场：脱口秀互怼大赛</h2>
    <p>周三的脱口秀对决堪称\"舌尖上的战争\"。两位以嘴皮子功夫著称的主播互相调侃，金句频出，被网友剪辑成了多个爆款短视频。</p>
    <h2>第四场：美食大胃王挑战</h2>
    <p>周四的比拼让观众看得直咽口水。两位美食主播进行了一场大胃王挑战赛，不仅要吃得快，还要吃出花样。最终两人都吃得撑到不行，画面十分搞笑。</p>
    <h2>第五场：周末狂欢大战</h2>
    <p>作为本周的压轴大戏，周五的对决汇集了前四场的精华元素。最后还邀请到了两位神秘嘉宾助阵，将整场比赛推向了高潮。</p>
    <p>以上就是上周五大经典对决的精彩回顾。记得关注51吃瓜黑料网\"每日大赛\"频道，不错过每一场精彩对决！</p>`,
    category: '每日大赛',
    categorySlug: 'daily-contest',
    imageUrl: 'https://readdy.ai/api/search-image?query=Abstract%20illustration%20of%20epic%20showdown%20highlights%2C%20vibrant%20coral%20and%20warm%20amber%20tones%2C%20stylized%20versus%20symbol%20and%20clash%20elements%2C%20sports%20entertainment%20aesthetic%2C%20dynamic%20diagonal%20composition%2C%20dramatic%20lighting%20effects%2C%20clean%20dark%20background&width=800&height=500&seq=art-010-main&orientation=landscape',
    author: '赛事观察员',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Abstract%20minimalist%20avatar%20illustration%20warm%20terracotta%20tones%20geometric%20abstract%20portrait%20clean%20background%20modern%20artistic%20style&width=120&height=120&seq=author-avatar-010&orientation=squarish',
    authorBio: '直播赛事专业评论员，见证过上千场精彩对决',
    publishDate: '2026-07-02',
    isTop: false,
    isHot: false,
    commentCount: 2890,
    viewCount: 110500,
    tags: ['每日大赛', '回顾', '热门'],
    relatedIds: ['art-003', 'art-006', 'art-008'],
  },
  {
    id: 'art-011',
    title: '某男团成员被曝与粉丝私下交往，经纪公司发表声明否认',
    excerpt: '有网友爆料某当红男团成员与粉丝存在私下交往关系，并附上了多张聊天截图。经纪公司迅速发布声明否认，但网友质疑声不断。',
    content: `<p>近日，有网友在社交平台上爆料称某当红男团成员与粉丝存在私下交往关系，并附上了多张聊天记录截图作为证据。这一消息迅速在粉丝圈内引起轩然大波。</p>
    <h2>爆料内容</h2>
    <p>根据爆料者提供的聊天截图，该男团成员与一位自称是其粉丝的女性有着频繁的私下交流。聊天内容从日常问候逐渐发展到了暧昧甚至是亲密的话题。</p>
    <p>爆料者还称，两人已经私下见面多次，甚至有证据显示该成员曾经为这位粉丝购买了昂贵的礼物。</p>
    <h2>粉丝反应</h2>
    <p>消息传出后，该男团的粉丝群体出现了明显的分裂。一部分粉丝表示心碎和失望，认为偶像辜负了他们的信任；另一部分则坚定地站在偶像一边，认为截图是伪造的。</p>
    <p>有粉丝在社交平台上发起了\"相信他\"的话题，短时间内就获得了数十万次的参与。但也有不少\"脱粉\"的粉丝在网上公开晒出了自己销毁周边产品的照片。</p>
    <h2>经纪公司声明</h2>
    <p>面对舆论压力，该男团的经纪公司在今天上午发布了一则官方声明。声明中否认了所有指控，称聊天截图是\"恶意拼接伪造\"的，并已向警方报案。</p>
    <p>声明还表示：\"我们将采取一切法律手段保护艺人的合法权益，对于恶意造谣者绝不姑息。\"</p>
    <h2>网友质疑</h2>
    <p>然而，部分网友对经纪公司的声明表示质疑。有技术专家分析了被曝光的聊天截图，认为\"伪造的可能性不大\"。</p>
    <p>还有网友发现，该男团成员最近的一些行为似乎与爆料的细节吻合，进一步加深了公众的怀疑。</p>`,
    category: '吃瓜前线',
    categorySlug: 'chigua',
    imageUrl: 'https://readdy.ai/api/search-image?query=Abstract%20illustration%20of%20idol%20fan%20relationship%20scandal%2C%20soft%20rose%20and%20blush%20tones%2C%20stylized%20heart%20breaking%20into%20pieces%2C%20dreamy%20romantic%20yet%20dramatic%20atmosphere%2C%20clean%20minimalist%20composition%2C%20soft%20gradient%20background&width=800&height=500&seq=art-011-main&orientation=landscape',
    author: '偶像观察员',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Abstract%20minimalist%20avatar%20illustration%20soft%20rose%20tones%20stylized%20heart%20shape%20abstract%20face%20clean%20background%20romantic%20design&width=120&height=120&seq=author-avatar-011&orientation=squarish',
    authorBio: '偶像产业深度观察者，见证无数饭圈风云',
    publishDate: '2026-07-01',
    isTop: false,
    isHot: false,
    commentCount: 5421,
    viewCount: 234500,
    tags: ['娱乐圈', '吃瓜', '八卦'],
    relatedIds: ['art-004', 'art-001', 'art-008'],
  },
  {
    id: 'art-012',
    title: '实锤揭秘：某直播平台内部算法被曝光，头部主播享有特殊权重',
    excerpt: '一位自称前平台员工的网友曝光了某直播平台的内部推荐算法，显示头部主播享有远超普通主播的流量权重。平台方面暂未回应。',
    content: `<p>一位自称是某大型直播平台前员工的网友在技术论坛上发布了一篇长文，详细曝光了该平台的内部推荐算法机制。文章显示，头部主播在算法中享有远超普通主播的特殊权重。</p>
    <h2>算法曝光细节</h2>
    <p>根据该网友的爆料，平台的推荐算法对主播进行了分级处理。头部主播（粉丝量超过100万）在推荐系统中享有5-8倍的流量加权，而新主播的推荐权重几乎为零。</p>
    <p>更令人关注的是，算法还会根据主播与平台的签约等级来进行流量分配。顶级签约主播即使在内容质量不如中小主播的情况下，也能获得更多的推荐曝光。</p>
    <h2>业内人士分析</h2>
    <p>多位技术领域的专家对曝光的算法进行了分析。有专家指出，这种流量分配方式虽然在商业逻辑上可以理解，但从公平竞争的角度来看确实存在问题。</p>
    <p>一位前互联网公司算法工程师表示：\"很多平台都会给头部内容创作者更多的权重，但如果差距过大，就会形成马太效应，不利于平台的长期发展。\"</p>
    <h2>中小主播反应</h2>
    <p>这篇爆料文章在中小主播群体中引起了强烈共鸣。许多主播表示，他们一直感觉平台的流量分配不公平，但苦于没有证据。</p>
    <p>一位拥有5万粉丝的主播说：\"我们辛辛苦苦做内容，结果流量全被大主播吃掉了。现在终于知道为什么了。\"</p>
    <h2>平台态度</h2>
    <p>截至目前，被曝光的直播平台尚未对此事做出正式回应。有消息称，平台内部已经启动了紧急调查，试图找出泄密者。</p>
    <p>行业监管部门也表示，将持续关注此事，确保直播行业的公平竞争环境。</p>`,
    category: '黑料实锤',
    categorySlug: 'heiliao',
    imageUrl: 'https://readdy.ai/api/search-image?query=Abstract%20illustration%20of%20algorithm%20manipulation%20exposure%2C%20muted%20teal%20and%20warm%20grey%20tones%2C%20stylized%20code%20and%20data%20flow%20patterns%2C%20tech%20whistleblower%20theme%2C%20modern%20investigative%20aesthetic%2C%20clean%20geometric%20composition%2C%20subtle%20digital%20grid%20background&width=800&height=500&seq=art-012-main&orientation=landscape',
    author: '科技调查员',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Abstract%20minimalist%20avatar%20illustration%20cool%20teal%20tones%20abstract%20circuit%20board%20face%20design%20clean%20background%20tech%20aesthetic&width=120&height=120&seq=author-avatar-012&orientation=squarish',
    authorBio: '科技领域调查记者，专攻互联网平台算法研究',
    publishDate: '2026-06-30',
    isTop: false,
    isHot: false,
    commentCount: 3876,
    viewCount: 167800,
    tags: ['黑料', '实锤', '爆料'],
    relatedIds: ['art-005', 'art-007', 'art-002'],
  },
];

export const hotComments = [
  {
    id: 'cmt-001',
    nickname: '吃瓜不嫌事大',
    avatar: 'https://readdy.ai/api/search-image?query=Abstract%20minimalist%20avatar%20illustration%20warm%20peach%20tones%20simple%20geometric%20face%20profile%20clean%20background%20modern%20design&width=120&height=120&seq=avatar-cmt-001&orientation=squarish',
    content: '这波操作太离谱了吧！我就说之前看他直播的时候就感觉不对劲，原来背后还有这么多故事。坐等更多实锤！',
    time: '2小时前',
    likes: 1289,
  },
  {
    id: 'cmt-002',
    nickname: '理性吃瓜群众',
    avatar: 'https://readdy.ai/api/search-image?query=Abstract%20minimalist%20avatar%20illustration%20soft%20coral%20tones%20simple%20circle%20face%20design%20clean%20background%20modern%20flat%20style&width=120&height=120&seq=avatar-cmt-002&orientation=squarish',
    content: '先别急着站队，等官方回应再说。不过话说回来，最近这种事情也太多了吧，娱乐圈是该好好整顿一下了。',
    time: '3小时前',
    likes: 867,
  },
  {
    id: 'cmt-003',
    nickname: '资深八卦研究员',
    avatar: 'https://readdy.ai/api/search-image?query=Abstract%20minimalist%20avatar%20illustration%20warm%20amber%20tones%20geometric%20abstract%20face%20clean%20background%20contemporary%20art%20style&width=120&height=120&seq=avatar-cmt-003&orientation=squarish',
    content: '作为关注这件事三年的老粉，我可以说这次爆出来的只是冰山一角。建议大家翻翻我之前的分析帖，很多线索早就在了。',
    time: '5小时前',
    likes: 2156,
  },
  {
    id: 'cmt-004',
    nickname: '纯路人甲',
    avatar: 'https://readdy.ai/api/search-image?query=Abstract%20minimalist%20avatar%20illustration%20soft%20beige%20tones%20simple%20geometric%20shape%20profile%20clean%20background%20minimal%20design&width=120&height=120&seq=avatar-cmt-004&orientation=squarish',
    content: '我就纯路过，但是看完整个事件经过真的震惊到我了。现在的网红圈水也太深了吧，一个比一个会玩。',
    time: '6小时前',
    likes: 534,
  },
  {
    id: 'cmt-005',
    nickname: '爆料小能手',
    avatar: 'https://readdy.ai/api/search-image?query=Abstract%20minimalist%20avatar%20illustration%20warm%20pink%20tones%20stylized%20face%20silhouette%20clean%20background%20modern%20graphic%20design&width=120&height=120&seq=avatar-cmt-005&orientation=squarish',
    content: '我这边还有更劲爆的料，就看小编敢不敢发了。反正我已经私信投稿了，大家拭目以待吧！',
    time: '8小时前',
    likes: 3421,
  },
  {
    id: 'cmt-006',
    nickname: '真相只有一个',
    avatar: 'https://readdy.ai/api/search-image?query=Abstract%20minimalist%20avatar%20illustration%20warm%20terracotta%20tones%20geometric%20abstract%20portrait%20clean%20background%20modern%20artistic%20style&width=120&height=120&seq=avatar-cmt-006&orientation=squarish',
    content: '整理了一下时间线，这件事从头到尾都很蹊跷。建议大家理性吃瓜，不要被带节奏。真相迟早会浮出水面的。',
    time: '10小时前',
    likes: 1876,
  },
];

export const statsData = [
  { label: '累计爆料', value: '12,800+', icon: 'ri-file-list-3-line' },
  { label: '日活用户', value: '580万+', icon: 'ri-user-line' },
  { label: '视频更新', value: '24h不间断', icon: 'ri-vidicon-line' },
  { label: '覆盖领域', value: '6大类目', icon: 'ri-grid-line' },
];

export const aboutInfo = {
  brandName: '51吃瓜黑料网',
  foundingYear: '2018',
  slogan: '吃瓜不迷路，黑料一手握',
  intro: `51吃瓜黑料网成立于2018年，是国内领先的娱乐八卦资讯聚合平台。我们以\"让每一颗瓜都真实、让每一条料都有据\"为使命，致力于为广大吃瓜群众提供最新、最全、最真实的娱乐资讯和热点追踪。

  经过多年的发展，51吃瓜黑料网已经成长为覆盖网曝门、每日大赛、网红猛料、视频不打烊、吃瓜前线、黑料实锤六大核心版块的综合性娱乐资讯平台。我们拥有一支专业的编辑团队和遍布全国的爆料网络，确保7×24小时不间断地为用户提供优质内容。

  我们的愿景是成为中国最受信赖的娱乐资讯平台，让每一位用户都能在这里找到自己关心的热点话题，参与到最火热的讨论中来。`,
  milestones: [
    { year: '2018', event: '51吃瓜黑料网正式上线，从零开始探索之路' },
    { year: '2019', event: '用户突破100万，开设\"网曝门\"专版' },
    { year: '2020', event: '推出\"每日大赛\"频道，日活突破200万' },
    { year: '2021', event: '上线\"视频不打烊\"频道，覆盖全平台内容' },
    { year: '2022', event: '用户总量突破1000万，成为行业标杆' },
    { year: '2023', event: '成立深度调查团队，推出\"黑料实锤\"栏目' },
    { year: '2024', event: '完成品牌升级，优化全站用户体验' },
    { year: '2025', event: '日活突破580万，持续领跑娱乐资讯赛道' },
  ],
  platformData: [
    { label: '累计用户', value: '2,380万+', icon: 'ri-user-star-line' },
    { label: '日均访问', value: '580万+', icon: 'ri-line-chart-line' },
    { label: '累计文章', value: '12.8万+', icon: 'ri-article-line' },
    { label: '日均互动', value: '50万+', icon: 'ri-chat-3-line' },
    { label: '覆盖主播', value: '3,200+', icon: 'ri-live-line' },
    { label: '合作伙伴', value: '800+', icon: 'ri-team-line' },
  ],
  cooperation: {
    email: 'hello@moonr.cn',
    phone: '400-888-5151',
    address: '北京市朝阳区互联网大街888号吃瓜大厦18层',
    wechat: 'chigua51_official',
    description: '51吃瓜黑料网欢迎各类商业合作，包括但不限于：品牌广告投放、内容营销合作、联合活动策划、数据调研服务等。我们拥有丰富的娱乐资讯资源和庞大的用户群体，能够为合作伙伴提供高效、精准的营销解决方案。',
  },
  faqs: [
    { q: '51吃瓜黑料网的内容来源是什么？', a: '我们的内容主要来源于三大渠道：专业编辑团队的深度挖掘与采编、遍布全国的用户爆料网络、以及合作伙伴提供的一手资讯。所有内容在发布前都经过编辑团队的核实与审核，确保信息的真实性和可靠性。' },
    { q: '如何向51吃瓜黑料网投稿或爆料？', a: '你可以通过网站首页的\"我要爆料\"入口提交爆料信息，也可以直接发送邮件至 hello@moonr.cn。我们会对每一条爆料信息进行认真审核，采纳后将给予爆料者相应的奖励。' },
    { q: '网站上的内容多久更新一次？', a: '我们承诺7×24小时不间断更新。编辑团队全天候值班，确保在热点事件发生的第一时间就能为读者带来最新报道。重要事件通常能在15分钟内完成首发报道。' },
    { q: '如何与51吃瓜黑料网进行商务合作？', a: '欢迎通过邮箱 hello@moonr.cn 或电话 400-888-5151 联系我们的商务团队。我们将在1个工作日内回复您的合作咨询，与您详细沟通合作方案。' },
    { q: '51吃瓜黑料网有移动端App吗？', a: '目前我们的移动端体验已经通过响应式网页设计进行了全面适配。您可以直接在手机浏览器中访问我们的网站，体验流畅的移动端内容。独立App正在开发中，敬请期待。' },
  ],
};